// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2HtWJ","info":"Note_info__Pqj0O","note":"Note_note__Y6Gh1","actions":"Note_actions__ACnAr"};